import { singleBottomMPUProps } from '../components/GptProperties';
import MoreNews from '../../News/containers/MoreNews';
import GptAdvert from '../components/GptAdvert';
import MostReadAll from '../containers/MostReadAll';
import React from 'react';
import PropTypes from 'prop-types';
import {RightColumn} from "./RightColumn";
import {StandardPage} from "./StandardPage";

export function SportHomePageContent(props) {
  const { location, sport, title, helmetProps, rightColumnContent } = props;

  return (
    <StandardPage sport={sport} title={title} helmetProps={helmetProps} >
      <div className="main-layout-left-column">
        <div id="left-more-news" className="main-layout-block">
          <MoreNews location={location} />
        </div>
        <div className='main-layout-block last-desktop'>
          <GptAdvert ocDetails={{ocSlot: [sport, 'leaderboard']}} performDetails={singleBottomMPUProps} />
        </div>
        <div id="left-most-read" className="main-layout-block last-handheld main-layout-hide-desktop">
          <MostReadAll location={location} />
        </div>
      </div>

      <RightColumn sport={sport} location={location} content={rightColumnContent} />
    </StandardPage>
  )
}

SportHomePageContent.propTypes = {
  location: PropTypes.object.isRequired,
  sport: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  helmetProps: PropTypes.object,
  rightColumnContent: PropTypes.array
};



// WEBPACK FOOTER //
// ./modules/Common/pages/SportHomePageContent.js